import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, Tabs, Tab } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import LevelChoose from '../../Components/LevelChoose';
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .contentWapper': {
        width: '100%',
        '& .tab': {
            backgroundColor: '#1A9AE7',
            color: '#fff',
        },
        '& .tabSelect': {
            backgroundColor: '#F9F7FA',
            color: '#1A9AE7',
        },
        '& .textWapper': {
            padding: '21px 47px',
            backgroundColor: '#F9F7FA',
            width: '100%',
            minHeight: '320px',
            '& .textField': {
                width: '100%',
                marginRight: '30px',
                backgroundColor: '#fff',
            },
        },
        '& .userWapper': {
            padding: '21px 47px 0 47px',
            backgroundColor: '#F9F7FA',
            width: '100%',
        },
    },
    '& .delWapper': {
        cursor: 'pointer',
        width: '108px',
        '& .del': {
            color: '#9B9B9B',
        },
    },
    '& .notesText': {
        width: '100%',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

class SendLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            tabIndex: 0,
            iEmails: [""],
            oEmails: [""],
            usersData: [],
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAddEmail = this.handleAddEmail.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const {
            iEmails,
            oEmails,
            tabIndex,
        } = this.state;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.btnName(this.props.state)}</Button>
            }
        }
        const showDelBtn = (index, name) => {
            if (index === 0 || this.isDisabled()) {
                return <div className="delWapper">
                </div>
            } else {
                return <div className="delWapper c" onClick={e => this.handleDelet(e, index, name)}>
                    <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
                </div>
            }
        }
        const showTabPanel = () => {
            if (tabIndex === 0) {
                return <div className="textWapper">
                    {iEmails.map((row, index) => (
                        <div className="h" key={index}>
                            <TextField
                                disabled={this.isDisabled()}
                                className="textField"
                                id="email"
                                label="Individual email address"
                                value={row}
                                onChange={e => this.handleEmailChange(e, index, 'iEmails')}
                                margin="dense"
                                variant="outlined"
                            />
                            {showDelBtn(index, 'iEmails')}
                        </div>
                    ))}
                    <Button color="primary" onClick={e => this.handleAddEmail(e, 'iEmails')}>
                        <AddIcon></AddIcon>
                        Send More Individual Clients
                    </Button>
                </div>
            } else if (tabIndex === 1) {
                return <div className="textWapper">
                    {oEmails.map((row, index) => (
                        <div className="h" key={index}>
                            <TextField
                                disabled={this.isDisabled()}
                                className="textField"
                                id="email"
                                label="Corporation email address"
                                value={row}
                                onChange={e => this.handleEmailChange(e, index, 'oEmails')}
                                margin="dense"
                                variant="outlined"
                            />
                            {showDelBtn(index, 'oEmails')}
                        </div>
                    ))}
                    <Button color="primary" onClick={e => this.handleAddEmail(e, 'oEmails')}>
                        <AddIcon></AddIcon>
                        Send More Corporation Clients
                    </Button>
                </div>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{this.props.title}</div>
                <div className="line"></div>
                <div className="contentWapper">
                    <Tabs
                        value={tabIndex}
                        className="tabs"
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleChange}
                        aria-label="disabled tabs example"
                        TabIndicatorProps={{ style: { display: "none" } }}
                    >
                        <Tab className={tabIndex === 0 ? "tabSelect" : "tab"} label="Individual" />
                        <Tab className={tabIndex === 1 ? "tabSelect" : "tab"} label="Corporation" />
                    </Tabs>
                    <div className="userWapper">
                        <LevelChoose
                            ref={(child) => { this.levelChoose = child }}
                            state={ADD}
                            isDisabled={false}
                        />
                    </div>
                    {showTabPanel()}
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.getUsers();
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    handleChange(e, newValue) {
        let tabIndex = newValue;
        this.setState(() => ({
            tabIndex
        }))
    }
    handleEmailChange(e, index, name) {
        const value = e.target.value;
        if (name === "iEmails") {
            const { iEmails } = this.state;
            let arr = iEmails;
            arr[index] = value;
            this.setState(() => ({
                iEmails: arr
            }))
        } else if (name === "oEmails") {
            const { oEmails } = this.state;
            let arr = oEmails;
            arr[index] = value;
            this.setState(() => ({
                oEmails: arr
            }))
        }
    }
    handleAddEmail(e, name) {
        const { iEmails, oEmails } = this.state;
        let arr = [];
        if (name === "iEmails") {
            arr = iEmails;
        } else if (name === "oEmails") {
            arr = oEmails;
        }
        if (arr.length >= 4) return;
        arr.push("")
        this.setState(() => ({
            [name]: arr
        }))
    }
    handleDelet(e, index, name) {
        const { iEmails, oEmails } = this.state;
        let arr = [];
        if (name === "iEmails") {
            arr = iEmails;
        } else if (name === "oEmails") {
            arr = oEmails;
        }
        arr.splice(index, 1);
        this.setState(() => ({
            [name]: arr
        }))
    }
    handleCreate() {
        const { iEmails, oEmails, tabIndex } = this.state;
        const teamObj = this.levelChoose.getData();
        const handler_id = teamObj.handler_id;
        const handler_team_id = teamObj.handler_team_id;
        this.props.handleCreate(tabIndex, iEmails, oEmails, handler_id, handler_team_id);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    //-------------------request-------------------------
    getUsers() {
        let params = {
            page_index: 1,
            page_size: 100
        }
        instance.get(BASE_URL + 'users', { params }).then((res) => {
            let usersData = res.data.data
            // console.log("user", usersData)
            this.setState(() => ({
                usersData
            }));
        })
    }
}

export default SendLink;